import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import CrmExportConflicts from "./CrmExportConflicts";

const labels = {
  created: "Created", filled: "Filled", skipped: "Skipped", unmatchable: "Unmatchable",
  duplicate_in_selection: "Duplicate selection", failed: "Failed", not_attempted: "Not attempted", associated: "Associated",
};

const headings = {
  completed: "Push completed", completed_with_failures: "Push completed with failures",
  failed: "Push stopped", canceled: "Push canceled",
};

const failures = {
  crm_required_properties_unmet: "HubSpot requires additional properties. Further writes stopped; completed records are preserved.",
  crm_disconnected: "HubSpot was disconnected. Reconnect in Settings before retrying.",
  crm_reconnect_required: "HubSpot authorization expired. Ask your account owner to reconnect in Settings.",
  portal_changed: "The connected HubSpot portal changed. Review the connection in Settings before creating a new preview.",
  crm_association_failed: "The contact could not be associated with the company. Retry failed companies to recover.",
};

export default function CrmExportResults({ model }) {
  return (
    <Box sx={{ mt: 2, overflowWrap: "anywhere" }}>
      {headings[model.status] && <Typography component="h3" variant="h6">{headings[model.status]}</Typography>}
      <Typography variant="body2" sx={{ mb: 2 }}>
        {model.processed_companies} of {model.counts.companies_total} companies processed · HubSpot portal {model.portal_id}
      </Typography>
      {model.failure_reason && <Alert severity="warning" sx={{ mb: 2 }}>{failures[model.failure_reason] || "This push could not finish. Review the outcomes and retry failed companies when the issue is resolved."}</Alert>}
      {model.required_properties.length > 0 && <Alert severity="error" sx={{ mb: 2 }}>Required HubSpot properties: {model.required_properties.join(", ")}</Alert>}
      {model.results.map((company) => (
        <Box key={company.company_id} sx={{ p: 1.5, mb: 1, border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
          <Typography sx={{ fontWeight: 600 }}>{company.company_id} · {labels[company.status]}</Typography>
          <Typography variant="body2">Company record {labels[company.record_status]?.toLowerCase()}{company.crm_company_id && ` · ID ${company.crm_company_id}`}</Typography>
          {company.error_code && <Typography variant="body2" color="error">{failures[company.error_code] || "This company could not finish. Retry failed companies to recover."}</Typography>}
          {company.required_properties.length > 0 && <Typography variant="body2" color="error">Required properties: {company.required_properties.join(", ")}</Typography>}
          {company.contacts.map((contact) => (
            <Box key={contact.email} sx={{ ml: 1.5, mt: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{contact.email} · {labels[contact.status]}</Typography>
              <Typography variant="body2">Contact record {labels[contact.record_status]?.toLowerCase()}{contact.crm_contact_id && ` · ID ${contact.crm_contact_id}`}</Typography>
              <Typography variant="body2">Association: {labels[contact.association_status]}</Typography>
              {contact.error_code && <Typography variant="body2" color="error">{failures[contact.error_code] || "This contact could not finish. Retry its company to recover."}</Typography>}
              {contact.required_properties.length > 0 && <Typography variant="body2" color="error">Required properties: {contact.required_properties.join(", ")}</Typography>}
            </Box>
          ))}
        </Box>
      ))}
      <CrmExportConflicts conflicts={model.conflicts} />
      <Typography variant="caption" color="text.secondary">Push reference: {model.export_id}</Typography>
    </Box>
  );
}
